module.exports = __webpack_public_path__ + "media/images/adverts/twitter-bc82019b7d034afac099ad402ab543ed.jpg";